import GoodPracticeHeader from "./components/NewGoodPracticeHeader";

export default GoodPracticeHeader;